"use strict";

var _regeneratorRuntime = require("C:\\Users\\Owner\\dao\\buildspace-dao-starter\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.call = exports.getChainId = exports.setChainIdOverride = exports.signData = exports.send = void 0;

var randomId = function randomId() {
  return Math.floor(Math.random() * 10000000000);
};

exports.send = function (provider, method, params) {
  return new Promise(function (resolve, reject) {
    var _a;

    var payload = {
      id: randomId(),
      method: method,
      params: params
    };

    var callback = function callback(err, result) {
      if (err) {
        reject(err);
      } else if (result.error) {
        console.error(result.error);
        reject(result.error);
      } else {
        resolve(result.result);
      }
    };

    var _provider = ((_a = provider.provider) === null || _a === void 0 ? void 0 : _a.provider) || provider.provider || provider;

    if (_provider.getUncheckedSigner
    /* ethers provider */
    ) {
      _provider.send(method, params).then(function (r) {
        return resolve(r);
      }).catch(function (e) {
        return reject(e);
      });
    } else if (_provider.sendAsync) {
      _provider.sendAsync(payload, callback);
    } else {
      _provider.send(payload, callback).catch(function (error) {
        if (error.message === "Hardhat Network doesn't support JSON-RPC params sent as an object") {
          _provider.send(method, params).then(function (r) {
            return resolve(r);
          }).catch(function (e) {
            return reject(e);
          });
        } else {
          throw error;
        }
      });
    }
  });
};

var splitSignatureToRSV = function splitSignatureToRSV(signature) {
  var r = '0x' + signature.substring(2).substring(0, 64);
  var s = '0x' + signature.substring(2).substring(64, 128);
  var v = parseInt(signature.substring(2).substring(128, 130), 16);
  return {
    r: r,
    s: s,
    v: v
  };
};

var signWithEthers = function signWithEthers(signer, fromAddress, typeData) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var signerAddress, _a, _unused, types, rawSignature;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return signer.getAddress();

          case 2:
            signerAddress = _context.sent;

            if (!(signerAddress.toLowerCase() !== fromAddress.toLowerCase())) {
              _context.next = 5;
              break;
            }

            throw new Error('Signer address does not match requested signing address');

          case 5:
            _a = typeData.types, _unused = _a.EIP712Domain, types = __rest(_a, ["EIP712Domain"]);
            _context.next = 8;
            return signer.signTypedData ? signer.signTypedData(typeData.domain, types, typeData.message) : signer._signTypedData(typeData.domain, types, typeData.message);

          case 8:
            rawSignature = _context.sent;
            return _context.abrupt("return", splitSignatureToRSV(rawSignature));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.signData = function (provider, fromAddress, typeData) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var typeDataString, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(provider._signTypedData || provider.signTypedData)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", signWithEthers(provider, fromAddress, typeData));

          case 2:
            typeDataString = typeof typeData === 'string' ? typeData : JSON.stringify(typeData);
            _context2.next = 5;
            return exports.send(provider, 'eth_signTypedData_v4', [fromAddress, typeDataString]).catch(function (error) {
              if (error.message === 'Method eth_signTypedData_v4 not supported.') {
                return exports.send(provider, 'eth_signTypedData', [fromAddress, typeData]);
              } else {
                throw error;
              }
            });

          case 5:
            result = _context2.sent;
            return _context2.abrupt("return", {
              r: result.slice(0, 66),
              s: '0x' + result.slice(66, 130),
              v: parseInt(result.slice(130, 132), 16)
            });

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

var chainIdOverride = null;

exports.setChainIdOverride = function (id) {
  chainIdOverride = id;
};

exports.getChainId = function (provider) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", chainIdOverride || exports.send(provider, 'eth_chainId'));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};

exports.call = function (provider, to, data) {
  return exports.send(provider, 'eth_call', [{
    to: to,
    data: data
  }, 'latest']);
};